import * as React from "react";
const SvgFiRrRestroomSimple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-restroom-simple_svg__a)">
      <path
        fill="#062147"
        d="M16.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m6.854 17.481a2.95 2.95 0 0 1-1.354.873v2.145a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0v-2.145a2.96 2.96 0 0 1-1.354-.873 2.54 2.54 0 0 1-.622-2.036l1.348-8.796C15.58 7.63 16.925 6 19 6s3.42 1.631 3.63 3.165l1.344 8.766.002.015a2.53 2.53 0 0 1-.622 2.035m-7.199-1.314c.182.209.483.333.807.333h4.078c.323 0 .625-.124.807-.333a.56.56 0 0 0 .149-.443l-1.344-8.771c-.084-.612-.65-1.452-1.651-1.452s-1.567.84-1.649 1.437l-1.348 8.797c-.025.183.068.338.151.434zM4 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m4 5v5c0 .886-.387 1.684-1 2.234V23a1 1 0 1 1-2 0v-5H3v5a1 1 0 1 1-2 0v-5.766c-.613-.55-1-1.347-1-2.234v-5c0-2.206 1.794-4 4-4s4 1.794 4 4m-3 6a1 1 0 0 0 1-1v-5c0-1.103-.897-2-2-2s-2 .897-2 2v5a1 1 0 0 0 1 1zm6-16a1 1 0 0 0-1 1v22a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-restroom-simple_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRestroomSimple;
